import React from 'react'
import { TextField, FormLabel } from '@material-ui/core';
import { Row, Col } from 'react-bootstrap';
import { FaChevronLeft } from 'react-icons/fa';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
const KategoriForm = (props) => {
    const defaultPage = props.defaultPage * 1 || 1;
    const defaultrowsPerPage = props.defaultrowsPerPage * 1 || 5;
    const kodeoutlet = props.kodeoutlet
    const goBack = () => {
        props.history.push(`/manajemenoutlet/${kodeoutlet}/listkaskeluar/${defaultPage}/${defaultrowsPerPage}`)
    }

    const handleChange = (ev) => {
        var value = ev.target.value;
        const key = ev.target.id || ev.target.name;
        props.handleChange(key, value)
    }

    return (
        <Row>
            <Col xs={12}>
                <h4 style={{ marginTop: 20, paddingBottom: 10 }} className="border-bottom"><FaChevronLeft onClick={goBack.bind(this)}  className="btnBack" />List Kas Keluar Form</h4>
            </Col>
            <Col xs={12} lg={12}>
                {(props.type == "edit" && !props.namabiaya) ? (
                    <React.Fragment>
                        <FormLabel>Nama Biaya</FormLabel>
                        <SkeletonTheme color="#fff" highlightColor="#ec7510">
                            <span className="skeleton-line">
                                <Skeleton />
                            </span>
                        </SkeletonTheme>
                    </React.Fragment>
                ) : (
                        <TextField
                            id="namabiaya"
                            name="namabiaya"
                            label="Nama Biaya"
                            fullWidth
                            required
                            multiline={false}
                            value={props.namabiaya}
                            onChange={handleChange}
                        />

                    )}

            </Col>
        </Row>

    )
}
export default KategoriForm;